<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  pipeline: { type: Object, required: true },
});

const emit = defineEmits(['confirm', 'cancel']);
const { t } = useI18n();

const confirmName = ref('');

const canConfirm = computed(
  () => confirmName.value.trim() === props.pipeline.name.trim()
);

function onConfirm() {
  if (!canConfirm.value) return;
  emit('confirm');
}
</script>

<template>
  <div
    class="fixed inset-0 z-[10010] flex items-center justify-center bg-black/40"
    @click.self="emit('cancel')"
  >
    <div
      class="bg-n-background rounded-xl shadow-2xl w-full max-w-sm mx-4 p-5 flex flex-col gap-4"
    >
      <div class="flex flex-col gap-1">
        <h3 class="text-sm font-semibold text-n-slate-12">
          {{ t('KANBAN.SETTINGS.DELETE_PIPELINE_CONFIRM_TITLE') }}
        </h3>
        <p class="text-xs text-n-slate-10">
          {{
            t('KANBAN.SETTINGS.DELETE_PIPELINE_CONFIRM_DESC', {
              name: pipeline.name,
            })
          }}
        </p>
      </div>

      <input
        v-model="confirmName"
        type="text"
        class="text-sm border border-n-weak rounded-lg px-3 py-2 bg-n-surface-2 text-n-slate-12 outline-none focus:border-n-ruby-6"
        :placeholder="pipeline.name"
        @keydown.enter.prevent="onConfirm"
      />

      <div class="flex justify-end gap-2 pt-1">
        <Button
          faded
          slate
          sm
          :label="t('KANBAN.FOLDERS.CANCEL')"
          type="button"
          @click="emit('cancel')"
        />
        <Button
          sm
          ruby
          :label="
            t('KANBAN.SETTINGS.DELETE_PIPELINE_CONFIRM_BTN', {
              name: pipeline.name,
            })
          "
          :disabled="!canConfirm"
          type="button"
          @click="onConfirm"
        />
      </div>
    </div>
  </div>
</template>
